export default function Method() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 animate-fade-in">
      <div className="max-w-5xl mx-auto">
        <div>
          <div className="text-xs text-stone-500 uppercase tracking-widest mb-2">
            METHOD
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-stone-800 mb-4">
            計算方法說明
          </h2>
          <p className="text-sm text-stone-600 leading-relaxed mb-4">
            本工具以 Dreamspell 13 月亮曆為基礎，並非傳統瑪雅長曆 (Tzolk'in)。
            基準日為{" "}
            <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
              1987-07-26 = Kin 34 (白銀河巫師 White Galactic Wizard)
            </code>
            。
          </p>
          <ul className="space-y-2 text-sm text-stone-600 leading-relaxed">
            <li className="flex gap-2">
              <span className="text-stone-400 flex-shrink-0">•</span>
              <span>
                Dreamspell 將 2/29 視為「校正日 / Hunab Ku (0.0)」，不算入
                Kin 編號。輸入 2/29 時，本頁顯示前後日的能量做參考。
              </span>
            </li>
            <li className="flex gap-2">
              <span className="text-stone-400 flex-shrink-0">•</span>
              <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
                kin = ((34 − 1 + Dreamspell 日差) mod 260) + 1
              </code>
            </li>
            <li className="flex gap-2">
              <span className="text-stone-400 flex-shrink-0">•</span>
              <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
                音頻 tone = ((kin − 1) mod 13) + 1
              </code>
            </li>
            <li className="flex gap-2">
              <span className="text-stone-400 flex-shrink-0">•</span>
              <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
                印記 seal = ((kin − 1) mod 20) + 1
              </code>
            </li>
            <li className="flex gap-2">
              <span className="text-stone-400 flex-shrink-0">•</span>
              <span>
                支持 = 印記對映 (1↔18、19↔20…即{" "}
                <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
                  19 − seal
                </code>{" "}
                wrap 1..20)，同音頻。
              </span>
            </li>
            <li className="flex gap-2">
              <span className="text-stone-400 flex-shrink-0">•</span>
              <span>
                挑戰 ={" "}
                <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
                  seal + 10
                </code>{" "}
                wrap，同音頻。
              </span>
            </li>
            <li className="flex gap-2">
              <span className="text-stone-400 flex-shrink-0">•</span>
              <span>
                隱藏 ={" "}
                <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
                  21 − seal
                </code>
                ，音頻為{" "}
                <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
                  14 − tone
                </code>
                。
              </span>
            </li>
            <li className="flex gap-2">
              <span className="text-stone-400 flex-shrink-0">•</span>
              <span>
                指引 = 同音頻，{" "}
                <code className="bg-stone-100 px-1 py-0.5 rounded text-xs text-stone-700">
                  seal + offset
                </code>
                ；offset 依音頻決定：1/6/11→0；2/7/12→12；3/8/13→4；4/9→16；5/10→8。
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}